import _ from 'lodash'
import UNIQUE from '@/common/unique'
import columnDetail from '../columnDetail'

export default {
  id: 'image2',
  name: 'image2',
  type: 'standard',
  moduleName: 'editor_module_image2',
  dataSet: {
    mods: 'flexible',
    column: [
      {
        columnId: UNIQUE.mid(),
        flex: 1,
        type: 'image',
        value: null,
        detail: {
          options: ['link', 'border', 'background', 'upload', 'radius'],
          link: _.cloneDeep(columnDetail.link),
          border: _.cloneDeep(columnDetail.border),
          background: _.cloneDeep(columnDetail.background),
          upload: _.cloneDeep(columnDetail.upload),
          radius: _.cloneDeep(columnDetail.radius)
        }
      },
      {
        columnId: UNIQUE.mid(),
        flex: 1,
        type: 'image',
        value: null,
        detail: {
          options: ['link', 'border', 'background', 'upload', 'radius'],
          link: _.cloneDeep(columnDetail.link),
          border: _.cloneDeep(columnDetail.border),
          background: _.cloneDeep(columnDetail.background),
          upload: _.cloneDeep(columnDetail.upload),
          radius: _.cloneDeep(columnDetail.radius)
        }
      }
    ]
  },
  setting: {
    layout: {
      options: [
        'link',
        'fullsize',
        'columns',
        'background',
        'border',
        'text',
        'padding'
      ]
    },
    action: null,
    detail: {}
  }
}
